import React, { useEffect } from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseCodes } from '../../../../modules/auth';
import _ from 'lodash';

const FormMultiCheckbox = ({
    name,
    label,
    filterObject,
    variant,
    margin,
    size,
    required,
    checkedList,
    onChangeChecked
}) => {
    const [checkList, setCheckList] = React.useState([]);


    const dispatch = useDispatch();
    const { baseCodes, error, loading } = useSelector(
        ({ auth, loading }) => ({
            baseCodes: auth.baseCodes,
            error: auth.baseCodesError,
            loading: loading['auth/GET_BASECODES'],
        }),
    );

    useEffect(() => {
        if (!baseCodes) {
            dispatch(getBaseCodes());
        } else {
            const filteredList = _.filter(baseCodes, filterObject);
            const orderedList = _.orderBy(filteredList, "step")
            setCheckList(orderedList);
        }
    }, [baseCodes]);



    return (
        <Box>
            <Typography variant="subtitle2" component="div">{label}</Typography>
            <Box>
                {checkList && checkList.map((item, index) => {
                    const findIndex = _.findIndex(checkedList, (checked) => checked === item.revVal1);
                    const checked = (findIndex !== -1) ? true : false;
                    return (
                        <FormControlLabel
                            key={index}
                            control={
                                <Checkbox checked={checked} name={item.revVal1} onChange={(event) => onChangeChecked(item.revVal1)} />
                            }
                            label={item.revVal2}
                        />
                    )
                })}
            </Box>
        </Box>
    )
}

export default FormMultiCheckbox